var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: "选择默认 banner",
        width: "800px",
        "append-to-body": "",
      },
      on: { close: _vm.handleClose },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            _vm._l(_vm.bannerList, function (item) {
              return _c("el-col", { key: item.id, attrs: { span: 8 } }, [
                _c(
                  "div",
                  {
                    staticStyle: { "text-align": "center", cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.handleSelect(item)
                      },
                    },
                  },
                  [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: item.id },
                        model: {
                          value: _vm.selectedId,
                          callback: function ($$v) {
                            _vm.selectedId = $$v
                          },
                          expression: "selectedId",
                        },
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            width: "120px",
                            height: "120px",
                            "object-fit": "cover",
                          },
                          attrs: { src: item.imgUrl },
                        }),
                        _c("div", { staticStyle: { "margin-top": "8px" } }, [
                          _vm._v(_vm._s(item.name)),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            }),
            1
          ),
          _c("el-pagination", {
            staticStyle: { "margin-top": "20px", "text-align": "right" },
            attrs: {
              "current-page": _vm.pagination.current,
              "page-size": _vm.pagination.pageSize,
              total: _vm.pagination.total,
              layout: "total, prev, pager, next",
            },
            on: { "current-change": _vm.handlePageChange },
          }),
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }